import { formatCompactMinutes } from '../utils/visitProjectTime';

interface UnassignedTimeStripProps {
  minutes: number;
}

/**
 * Clocked-in time no visit or drive accounts for, as its own summary line.
 * Total Hours and Store+Drive can legitimately differ — that difference just
 * can't be invisible, or a bare pay stretch sits between the tiles with
 * nothing pointing at it. Compact minutes, not decimal hours: a 2-minute gap
 * as "0.0h" reads as a glitch and teaches reps to ignore the strip.
 */
export default function UnassignedTimeStrip({ minutes }: UnassignedTimeStripProps) {
  if (minutes < 1) return null;
  return (
    <div
      data-testid="unassigned-time-strip"
      className="mt-3 rounded-lg bg-amber-50 p-3"
    >
      <span className="text-lg font-bold text-amber-800">{formatCompactMinutes(minutes)}</span>
      <span className="ml-2 text-xs text-amber-700">
        Unassigned — clocked-in time with no visit or drive recorded
      </span>
    </div>
  );
}
